import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IAppointment } from '../../../models/appointment.interface';
import { environment } from '../../../../environments/environment';
import { SoapServiceService } from '../../../services/soap-service/soap-service.service';
@Component({
    standalone: false,
    selector: 'cva-consultation-grid-view',
    templateUrl: './consultation-grid-view.component.html',
    styleUrl: './consultation-grid-view.component.scss',
    
})
export class ConsultationGridViewComponent implements OnInit{
  @Input() appointment!: IAppointment;
  @Output() switchToTabMode: EventEmitter<boolean> = new EventEmitter<boolean>();

  cvaUI_url = environment.cvaUI_url;
  recordedTranscription: string = '';

  constructor(private readonly  soapServiceService: SoapServiceService) { }

  ngOnInit(): void {
    const selectedAppointment = this.soapServiceService.getAppointmentAndDraftedNotes();
    this.recordedTranscription = selectedAppointment?.referenceId ?
      selectedAppointment.transcription :
      this.appointment.transcription;
  }

  switchToEditMode() {
    this.switchToTabMode.emit(true);
  }
}
